import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/api/client";

const SiteContentCtx = createContext({ content: {}, t: (_k, fallback = "") => fallback, refresh: () => {} });

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState({});

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/site-content");
      setContent(data || {});
    } catch {
      /* keep whatever we had */
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const t = useCallback((key, fallback = "") => {
    const v = content[key];
    return (v === undefined || v === null || v === "") ? fallback : v;
  }, [content]);

  return (
    <SiteContentCtx.Provider value={{ content, t, refresh }}>
      {children}
    </SiteContentCtx.Provider>
  );
}

export const useSiteContent = () => useContext(SiteContentCtx);
